import { render, staticRenderFns } from "./CreateWhatsNew.vue?vue&type=template&id=c9d88baa&scoped=true"
import script from "./CreateWhatsNew.vue?vue&type=script&lang=js"
export * from "./CreateWhatsNew.vue?vue&type=script&lang=js"
import style0 from "./CreateWhatsNew.vue?vue&type=style&index=0&id=c9d88baa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9d88baa",
  null
  
)

export default component.exports